{/* eslint-disable @typescript-eslint/no-empty-function */}
import React, { useState } from 'react';
import AddFunds from './addFunds';
import Addpayment from './addPayment';
import AddBank from './addPayment/AddBank';
import PointsConverter from './pointsConverter/PointsConverter';
import SendToFriend from './send';
import AddExisting from './add/Existing';
import { Actionsheet, ChevronLeftIcon, SmallCloseIcon, Box, ScrollView, ToastProvider, useTheme, useColorMode } from 'native-base';
import { GIFTCARD_FLOWS, GiftCard, observer, useCreateGiftCardPayment, useI18n, useSpringBigStore } from '@springbig/shared';
import { useGeneralStyles } from '~/shared/styles';
import SentMessage from './send/SentMessage';
import AddGiftCard from './add/Add';
import Pressable from '~/shared/Pressable';
import { useToast } from '~/hooks/toast';
import ManagePayment from './managePayment';
import CreditCardForm from '~/shared/CreditCardForm/CreditCardForm';
import { CreditCardDto } from '~/shared/CreditCardForm/hooks/useCreditCardForm';
import { Caption } from '~/shared/Typography';

const ActionSheetContent = ({
    currentActionSheetItem,
    isOpen,
    currentFlow,
    manageGiftCard,
    data,
    setGiftCardValue,
    setIsCompletedModalOpen
}: {
    currentActionSheetItem: GIFTCARD_FLOWS,
    isOpen: boolean,
    currentFlow: GIFTCARD_FLOWS[],
    manageGiftCard: GiftCard | null,
    data: any,
    setGiftCardValue: (value: number) => void
    setIsCompletedModalOpen: (value: boolean) => void
}) => {

    const { member } = useSpringBigStore();
    const {
        mutate: createGiftCardPayment,
        isLoading,
    } = useCreateGiftCardPayment();
    const [addCardError, setAddCardError] = useState(null);
    const gStyle = useGeneralStyles();
    const { giftCards } = useSpringBigStore();
    const onClose = () => {

        setIsConfirmState(false);
        observer.emit('close-actionsheet');
    };

    const { t } = useI18n();
    const { successToast } = useToast();
    const theme = useTheme();
    const { colorMode } = useColorMode();
    const bottomSheetBackgroundColor = (theme.colors as any)[`general:${colorMode}` ].section_background === 'none' ? (colorMode === 'dark' ? 'dark' : 'light') : gStyle.section_background;
    const [isConfirmState, setIsConfirmState] = useState(false);

    const CurrentStep = () => {

        if (currentActionSheetItem === 'CONVERT_POINTS_TO_CASH' && !giftCards.length) {
            return <AddFunds
                manageGiftCard={manageGiftCard}
                t={t}
                successToast={successToast}
                isPurchaseWithPoints={true}
                setGiftCardValue={setGiftCardValue}
                setIsCompletedModalOpen={setIsCompletedModalOpen}
                isConfirmState={isConfirmState}
                setIsConfirmState={setIsConfirmState}
            />;
        }

        if (currentActionSheetItem === 'NULL' && isOpen) {
            onClose();
        }

        switch (currentActionSheetItem) {
        case GIFTCARD_FLOWS.addFunds:
            return <AddFunds
                manageGiftCard={manageGiftCard}
                t={t}
                successToast={successToast}
                isPurchaseWithPoints={false}
                setGiftCardValue={setGiftCardValue}
                setIsCompletedModalOpen={setIsCompletedModalOpen}
                isConfirmState={isConfirmState}
                setIsConfirmState={setIsConfirmState}
            />;
        case GIFTCARD_FLOWS.addPayment:
            return <Addpayment t={t} />;
        case GIFTCARD_FLOWS.addPaymentBank:
            return <AddBank t={t} />;
        case GIFTCARD_FLOWS.addPaymentCard:
            return <CreditCardForm
                t={t}
                onCancel={() => {}}
                onProceed={(creditCardDto: CreditCardDto) => {

                    member && createGiftCardPayment({
                        member_id: member?.id.toString() || '',
                        name: creditCardDto.name,
                        number: creditCardDto.number,
                        expiry: creditCardDto.expiry,
                        cvv: creditCardDto.cvv,
                        zip: creditCardDto.zip,
                        payment_type: 'card'
                    }, {
                        onSuccess: () => {

                            observer.emit('giftcard-back');
                            observer.emit('giftcard-back');
                        },
                        // eslint-disable-next-line handle-callback-err
                        onError: (error: unknown) => {
                            setAddCardError([(error as { data: { message: string }}).data.message]);
                        }
                    });
                }}
                showCancel={false}
                titleComponent={
                    <Box alignItems={'center'}>
                        <Caption fontSize={24}>
                            { t('general.add') } { t('general.payment') }
                        </Caption>
                        <Caption fontSize={22} fontWeight={'200'}>
                            { t('giftCard.addPayment.addCard.caption') }
                        </Caption>
                    </Box>
                }
                isLoading={isLoading}
                error={addCardError}
            />;
        case GIFTCARD_FLOWS.convertPointsToCash:
            return <PointsConverter t={t} />;
        case GIFTCARD_FLOWS.sentGift:
            return <SentMessage t={t} data={data} />;
        case GIFTCARD_FLOWS.sendGiftCard:
            return <SendToFriend t={t} />;
        case GIFTCARD_FLOWS.addGiftCard:
            return <AddGiftCard t={t} />;
        case GIFTCARD_FLOWS.existingGiftCard:
            return <AddExisting t={t} />;
        case GIFTCARD_FLOWS.managePayment:
            return <ManagePayment t={t} />;
        }
    };

    const IconManager = () => {

        if (currentActionSheetItem === GIFTCARD_FLOWS.addFunds && isConfirmState) {
            return <></>;
        }

        if (currentFlow.length > 1) {
            return <Pressable onPress={() => observer.emit('giftcard-back')}>
                <ChevronLeftIcon size='lg' color={gStyle.button_background} />
            </Pressable>;
        }

        return <Pressable onPress={onClose}>
            <SmallCloseIcon size='md' color={gStyle.button_background} />
        </Pressable>;
    };

    return (
        <Actionsheet isOpen={isOpen} onClose={onClose} hideDragIndicator>
            <Actionsheet.Content backgroundColor={bottomSheetBackgroundColor} zIndex={9999} overflow='auto' w={'clamp(320px, 100vw, 480px)'} alignSelf='center'>
                <ToastProvider>
                    <ScrollView w='100%'>
                        <Box alignSelf={'flex-start'}>
                            <IconManager />
                        </Box>
                        <Box w='85%' alignSelf='center' mb={70}>
                            {CurrentStep()}
                        </Box>
                    </ScrollView>
                </ToastProvider>
            </Actionsheet.Content>
        </Actionsheet>
    );
};


export default ActionSheetContent;
